import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import DownloadIcon from '@mui/icons-material/Download';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// Files Container
const FilesContainer = ({ filesList }) => {
  let imgFiles = [];
  let otherFiles = [];

  filesList.map((file) => {
    if (file.lastIndexOf(".") > 0) {
      const fileType = file.substring(file.lastIndexOf(".") + 1, file.length).toLowerCase();

      if (fileType === "jpg" || fileType === "png") imgFiles.push(file);
      else otherFiles.push(file);
    }
  });

  return (
    <>
      <ImageList sx={{ width: "100%", maxHeight: "500px" }} cols={2} rowHeight={100}>
        {imgFiles.map((image) => (
          <ImageListItem key={image.split("/").pop()}>
            <img
              style={{ height: "80px", width: "80px", objectFit: "cover" }}
              crossOrigin="anonymous"
              alt="Job"
              src={
                image
                  ? process.env.REACT_APP_API_URL + "/" + image
                  : process.env.REACT_APP_API_URL + "/file/jobs/NoImageAvailable.png"
              }
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>

      <aside>
        <ul style={{ marginTop: 0 }}>
          {otherFiles.map((file) => (
            <li key={file}>{file.slice(file.indexOf("-") + 1)}</li>
          ))}
        </ul>
      </aside>
    </>
  );
};

// Function for download files
const downloadFiles = (filesList) => {
  filesList.forEach((file) => window.open(process.env.REACT_APP_API_URL + "/" + file, "_blank"));
};

// Function for display icon in table row
const RowIcon = ({ icon, rowData }) => {
  switch(icon) {
    case "Download":
      return rowData.files ? <DownloadIcon sx={{ cursor: "pointer" }} onClick={() => downloadFiles(rowData.files)} /> : ('');
    default:
      return ('');
  }
};

const HistoryTable = ({ columns, history, historyLoading }) => {
  if (historyLoading) return "Loading...";

  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 2, wordBreak: "break-all" }}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table" stickyHeader>
          <TableHead>
            <StyledTableRow>
              {columns.map((col) => (
                <StyledTableCell align="left" key={col.id} style={{ width: `${col.width}px` }}>
                  {col.label}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {history.map((row, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {columns.map((col) => (
                  <StyledTableCell key={col.id} align="left">
                    {row[col.id] ? (
                      col.id == "files" ? <FilesContainer filesList={row[col.id]} /> : row[col.id]
                    ) : (col.icon ? <RowIcon icon={col.icon} rowData={row} /> : ("-"))}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default HistoryTable;
